import React from "react";
import CheckBox from "../../../../components/checkbox";
import Input from "../../../../components/input";
import TextArea from "../../../../components/textArea";
import { DataView } from "../../../../styles/elements/main";
import { FormGroup, FormRow, StyledLabel } from "../../../../styles/forms/main";
const SupplierPricingDetails = ({
    supplierConditions,
    isEditable,
    showEditableField,
    handleSupplierPricingOnChange,
    supplierWorkingConditionIsValid,
}) => {
    return (
        <div>
            <h3>Supplier Pricing Details</h3>

            <FormRow>
                <FormGroup>
                    <Input
                        step="0.01"
                        disableWithBorder={false}
                        isEditable={isEditable || showEditableField}
                        label="Truck price per month"
                        name="truckPricePerMonth"
                        type="number"
                        onChange={(e) =>
                            handleSupplierPricingOnChange(e.target.value, "truckPricePerMonth")
                        }
                        required={true}
                        value={supplierConditions?.pricingDetails?.truckPricePerMonth}
                        min="1"
                        error={
                            !supplierWorkingConditionIsValid &&
                            (isEditable || showEditableField) &&
                            supplierConditions?.pricingDetails?.truckPricePerMonth === 0
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <Input
                        step="0.01"
                        disableWithBorder={false}
                        isEditable={isEditable || showEditableField}
                        label="Extra Day Price"
                        name="extraDayPrice"
                        type="number"
                        onChange={(e) =>
                            handleSupplierPricingOnChange(e.target.value, "extraDayPrice")
                        }
                        required={true}
                        value={supplierConditions?.pricingDetails?.extraDayPrice}
                        min="1"
                        error={
                            !supplierWorkingConditionIsValid &&
                            (showEditableField || isEditable) &&
                            supplierConditions?.pricingDetails.extraDayPrice === 0
                        }
                    />
                </FormGroup>
            </FormRow>
            <FormRow>
                <FormGroup>
                    <Input
                        step="0.01"
                        disableWithBorder={false}
                        isEditable={isEditable || showEditableField}
                        label="Extra Working Hour Price"
                        name="extraHoursPrice"
                        type="number"
                        onChange={(e) =>
                            handleSupplierPricingOnChange(e.target.value, "extraHourPrice")
                        }
                        required={true}
                        value={supplierConditions?.pricingDetails?.extraHourPrice}
                        min="1"
                        error={
                            !supplierWorkingConditionIsValid &&
                            (isEditable || showEditableField) &&
                            supplierConditions?.pricingDetails?.extraHourPrice === 0
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <Input
                        step="0.01"
                        disableWithBorder={false}
                        isEditable={isEditable || showEditableField}
                        label="Extra Kilometer Price"
                        name="extraKiloMeterPrice"
                        type="number"
                        onChange={(e) =>
                            handleSupplierPricingOnChange(e.target.value, "extraUnitDistancePrice")
                        }
                        required
                        value={supplierConditions?.pricingDetails?.extraUnitDistancePrice}
                        min="1"
                        error={
                            !supplierWorkingConditionIsValid &&
                            (isEditable || showEditableField) &&
                            supplierConditions?.pricingDetails?.extraUnitDistancePrice === 0
                        }
                    />
                </FormGroup>
            </FormRow>
            <FormRow>
                <FormGroup>
                    <Input
                        disableWithBorder={false}
                        isEditable={isEditable || showEditableField}
                        label="Over Night Stay Price %"
                        name="overNightPrice"
                        type="number"
                        onChange={(e) =>
                            handleSupplierPricingOnChange(e.target.value, "overnightPrice")
                        }
                        required
                        value={supplierConditions?.pricingDetails?.overnightPrice}
                        min="1"
                        max="100"
                        error={
                            !supplierWorkingConditionIsValid &&
                            (isEditable || showEditableField) &&
                            supplierConditions?.pricingDetails?.overnightPrice === 0
                        }
                    />
                </FormGroup>
            </FormRow>
            <FormRow>
                {supplierConditions?.fullFillmentDetails?.numberOfHelpers > 0 && (
                    <FormGroup>
                        <Input
                            step="0.01"
                            disableWithBorder={false}
                            isEditable={isEditable || showEditableField}
                            label="Helper Daily Wage"
                            name="helperWage"
                            type="number"
                            onChange={(e) =>
                                handleSupplierPricingOnChange(e.target.value, "pricePerHelper")
                            }
                            required={supplierConditions?.fullFillmentDetails?.numberOfHelpers > 0}
                            value={supplierConditions?.pricingDetails?.pricePerHelper}
                            min="1"
                            error={
                                !supplierWorkingConditionIsValid &&
                                (isEditable || showEditableField) &&
                                supplierConditions?.pricingDetails?.pricePerHelper === 0
                            }
                        />
                    </FormGroup>
                )}
                {supplierConditions?.fullFillmentDetails?.deliveryDelegate > 0 && (
                    <FormGroup>
                        <Input
                            step="0.01"
                            disableWithBorder={false}
                            isEditable={isEditable || showEditableField}
                            label="Delegate Daily Wage"
                            name="delegateWage"
                            type="number"
                            onChange={(e) =>
                                handleSupplierPricingOnChange(e.target.value, "pricePerDelegate")
                            }
                            required={supplierConditions?.fullFillmentDetails?.deliveryDelegate > 0}
                            value={supplierConditions?.pricingDetails?.pricePerDelegate}
                            min="1"
                            error={
                                !supplierWorkingConditionIsValid &&
                                (isEditable || showEditableField) &&
                                supplierConditions?.pricingDetails?.pricePerDelegate === 0
                            }
                        />
                    </FormGroup>
                )}
            </FormRow>
            {(isEditable || showEditableField) && (
                <FormRow>
                    <FormGroup>
                        <CheckBox
                            label="Exclude Fuel & Oil"
                            name="excludeGasAndOil"
                            type="checkbox"
                            onChange={(e) => {
                                handleSupplierPricingOnChange(e.target.checked, "excludeGasAndOil");
                            }}
                            value={supplierConditions?.pricingDetails?.excludeGasAndOil || false}
                        />
                    </FormGroup>
                </FormRow>
            )}
            {supplierConditions?.pricingDetails?.excludeGasAndOil && (
                <FormRow>
                    <FormGroup>
                        <Input
                            step="0.01"
                            disableWithBorder={false}
                            isEditable={isEditable || showEditableField}
                            label="Fuel & Oil Price per Kilometer"
                            name="GazPricePerkiloMeter"
                            type="number"
                            onChange={(e) => {
                                handleSupplierPricingOnChange(
                                    e.target.value,
                                    "GazPricePerkiloMeter"
                                );
                            }}
                            required={supplierConditions?.pricingDetails?.excludeGasAndOil}
                            placeholder="1"
                            value={supplierConditions?.pricingDetails?.GazPricePerkiloMeter}
                            min="1"
                            error={
                                !supplierWorkingConditionIsValid &&
                                (isEditable || showEditableField) &&
                                supplierConditions?.pricingDetails?.GazPricePerkiloMeter === 0
                            }
                        />
                    </FormGroup>
                    <FormGroup>
                        <StyledLabel>Total Fuel & Oil Price </StyledLabel>
                        {supplierConditions?.pricingDetails.GazPricePerkiloMeter &&
                            supplierConditions?.salesConditions?.kiloMeters && (
                                <DataView>
                                    {supplierConditions?.pricingDetails.GazPricePerkiloMeter *
                                        supplierConditions?.salesConditions?.kiloMeters}
                                </DataView>
                            )}
                    </FormGroup>
                </FormRow>
            )}
            {((supplierConditions?.pricingDetails?.otherDetails !== "" &&
                supplierConditions?.pricingDetails?.otherDetails !== null) ||
                isEditable ||
                showEditableField) && (
                <FormRow>
                    <TextArea
                        isEditable={isEditable || showEditableField}
                        type="text"
                        name="otherDetails"
                        onChange={(e) => {
                            handleSupplierPricingOnChange(e.target.value, "otherDetails");
                        }}
                        label="Other Details"
                        placeholder=""
                        value={supplierConditions?.pricingDetails?.otherDetails}
                    />
                </FormRow>
            )}
        </div>
    );
};

export default SupplierPricingDetails;
